import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2198c941")

_pushScopeId("data-v-2198c941")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_ctx.column)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.column.editorType !== 'COMBO' && _ctx.column.columnInfo.type !== 'date' && _ctx.column.columnInfo.type !== 'timestamp')
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 0,
              style: _ctx.knPivotTableDescriptor.pivotStyles.inputFields,
              class: "kn-material-input",
              type: _ctx.setDataType(_ctx.column.columnInfo.type),
              step: _ctx.getStep(_ctx.column.columnInfo.type),
              modelValue: _ctx.row[_ctx.column.field].data,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.row[_ctx.column.field].data = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('rowChanged', _ctx.row)))
            }, null, 8, ["style", "type", "step", "modelValue"]))
          : (_ctx.column.columnInfo.type === 'date' || _ctx.column.columnInfo.type === 'timestamp')
            ? (_openBlock(), _createBlock(_component_Calendar, {
                key: 1,
                style: _ctx.knPivotTableDescriptor.pivotStyles.inputFields,
                class: "pivot-calendar",
                modelValue: _ctx.row[_ctx.column.field].data,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.row[_ctx.column.field].data = $event)),
                showTime: _ctx.column.columnInfo.type === 'timestamp',
                showSeconds: _ctx.column.columnInfo.type === 'timestamp',
                showButtonBar: true,
                onDateSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('rowChanged', _ctx.row))),
                dateFormat: _ctx.column.columnInfo.type === 'date' ? _ctx.getCurrentLocaleDefaultDateFormat(_ctx.column) : ''
              }, null, 8, ["style", "modelValue", "showTime", "showSeconds", "dateFormat"]))
            : (_ctx.column.editorType === 'COMBO')
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 2,
                  class: "kn-material-input",
                  modelValue: _ctx.row[_ctx.column.field].data,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.row[_ctx.column.field].data = $event)),
                  options: _ctx.columnOptions[_ctx.column.field] ? _ctx.columnOptions[_ctx.column.field][_ctx.row[_ctx.column.dependences]?.data] : [],
                  placeholder: _ctx.$t('documentExecution.registry.select'),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('dropdownChanged', { row: _ctx.row, column: _ctx.column }))),
                  onBeforeShow: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('dropdownOpened', { row: _ctx.row, column: _ctx.column })))
                }, {
                  value: _withId((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_2, [
                          _createVNode("span", null, _toDisplayString(slotProps.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withId((slotProps) => [
                    _createVNode("div", null, [
                      _createVNode("span", null, _toDisplayString(slotProps.option['column_1']), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "placeholder"]))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})